export default __webpack_public_path__ + "static/media/tab.bef209a8.png";